import { render } from "./Preloader.vue?vue&type=template&id=bb2a5bd4&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=bb2a5bd4&lang=scss&scoped=true"

import exportComponent from "D:\\ProjectsWeb\\road-maintenance-launcher\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2a5bd4"]])

export default __exports__